import { DiffPercentageBadge } from "ui";
import { ChartCard } from "./ChartCard";
import { useDatadogQuery } from "./useDatadogQuery";
import { percentageFormatter } from "./utils";

type RecoveryChart =
  | "RECOVERY_RATE"
  | "OVERALL_SOFT_DECLINE_RECOVERY"
  | "SOFT_DECLINE_COVERAGE";

type RecoveryKPIData = {
  rate: number;
  numerator: number;
  denominator: number;
  counts: {
    recovery_entered_intents: number;
    recovered_successful_intents: number;
    first_attempt_soft_decline_intents: number;
    soft_decline_recovery_entered_intents: number;
  };
  previous: {
    rate: number;
    numerator: number;
    denominator: number;
  };
  diff_percentage: number | null;
};

export function RecoveryRateCard({
  chartType,
  title,
  description,
}: {
  chartType: RecoveryChart;
  title: string;
  description: string;
}) {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<RecoveryKPIData>({ chartType });

  const rate = data?.rate ?? 0;
  const diffPercentage = data?.diff_percentage ?? null;

  return (
    <ChartCard
      ref={ref}
      title={title}
      description={description}
      className="aspect-[5/3]"
      contentClassName="h-auto flex-1 justify-center"
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
    >
      <div className="flex flex-col items-center justify-center gap-3 py-6">
        <span className="text-4xl font-bold text-foundations-boldest">
          {percentageFormatter(rate)}%
        </span>
        {diffPercentage !== null && (
          <div className="flex items-center gap-2">
            <DiffPercentageBadge
              diffPercentage={diffPercentage}
              variant={diffPercentage >= 0 ? "success" : "danger"}
            />
          </div>
        )}
      </div>
    </ChartCard>
  );
}
